module.exports = __webpack_public_path__ + "static/media/Leuctra.2e98f5b2.jpg";